import React, { useState, useEffect } from "react";
import { DataGrid } from "@material-ui/data-grid";
import LoadingSimpleBackdrop from "../../tools/LoadingSimpleBackdrop";
import ValidateRequest from "../../tools/ValidateImmobilisationStepRequest";
import InventoryService from "../../../services/InventoryService";
import Title from "../../../components/Title";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import {
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  Checkbox,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions
} from "@material-ui/core";

import ArticleIcon from "@mui/icons-material/Article";
import { style } from "@mui/system";
import { id } from "date-fns/locale";
import { useNavigate } from "react-router-dom";
import Message from "../../tools/Message";
import Spacer from "../../../components/Spacer";
import ImmobilisationService from "../../../services/ImmobilisationService";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    elevation: 0,
  },
  style1: {
    backfaceVisibility: "cyan",
  },
}));

// Liste des IDs autorisés à envoyer un rappel de validation
// Ces utilisateurs (responsables logistiques) doivent attendre que les deux statuts soient CONFIRMED
// POUR LEUR RÔLE DE VALIDATION FINALE, mais s'ils sont eux-mêmes détenteurs d'une ligne,
// ils gardent leurs droits de détenteur sur cette ligne.
const ALLOWED_REMINDER_USER_IDS = [144, 162, 27, 164, 34, 23, 31, 77, 142, 167, 396];

export default function ImmobilisationMineTable() {
  const [rows, setRows] = useState([]);
  const [immoArray, setImmoArray] = useState([]);
  const classes = useStyles();
  const navigate = useNavigate();

  const [openLoadingSimpleBackdrop, setOpenLoadingSimpleBackdrop] = React.useState(false);
  const [message, setMessage] = useState({
    open: false,
    color: 'green',
    messageInfo: '',
  });
  const { open, color, messageInfo } = message;
  const [openValidateRequest, setOpenValidateRequest] = useState(false);
  const [immoHistoryId, setImmoHistoryId] = useState([]);
  const [state, setState] = useState(false);
  const userConnectedId = localStorage.getItem("USER");

  const [selectedImmobilisations, setSelectedImmobilisations] = useState([]);
  const [immoAffectation, setImmoAffectation] = useState([]);

  // État pour la pagination
  const [pageSize, setPageSize] = useState(10);

  // État pour le dialogue de rappel de validation
  const [openReminderDialog, setOpenReminderDialog] = useState(false);
  const [selectedReminderItem, setSelectedReminderItem] = useState(null);
  // État pour éviter les double-clics / indiquer un envoi en cours
  const [sendingReminder, setSendingReminder] = useState(false);

  // Vérifie si l'utilisateur connecté est un responsable logistique autorisé
  const isLogisticsResponsible = () => {
    const userId = Number(userConnectedId);
    return ALLOWED_REMINDER_USER_IDS.includes(userId);
  };

  // Vérifie si l'utilisateur connecté est concerné par la ligne

  const isUserConcernedByRow = (row) => {
    // const currentUserId = Number(userConnectedId);
    // if (!currentUserId) return false;

    // const isOldHolder = Number(row.older_id) === currentUserId;
    // const isNewHolder = Number(row.new_affectation_user_id) === currentUserId;

    // return isOldHolder || isNewHolder;
    return true;
  };

  // ============================================================
  // RÈGLE DE COCHAGE
  // ------------------------------------------------------------
  // Le droit de cocher dépend de DEUX dimensions indépendantes :
  //   1) Est-ce que l'utilisateur est CONCERNÉ par la ligne ? (détenteur)
  //   2) Est-ce que l'utilisateur est RESPONSABLE LOGISTIQUE ?
  //
  // - Si CONCERNÉ → peut TOUJOURS cocher (même si PENDING).
  //   (Un responsable logistique qui est aussi détenteur garde ce droit.)
  //
  // - Sinon, si RESPONSABLE LOGISTIQUE → peut cocher UNIQUEMENT
  //   quand les DEUX statuts sont CONFIRMED.
  //
  // - Sinon (utilisateur lambda non concerné) → peut cocher
  //   seulement si aucun statut n'est PENDING.
  // ============================================================
  const canBeSelected = (row) => {
    const isOldHolderPending = row.status_by_the_old_holder === "PENDING";
    const isHolderPending = row.status_by_the_holder === "PENDING";
    const hasPendingStatus = isOldHolderPending || isHolderPending;

    const bothConfirmed =
      row.status_by_the_old_holder === "CONFIRMED" &&
      row.status_by_the_holder === "CONFIRMED";

    const isConcerned = isUserConcernedByRow(row);
    const isLogisticsUser = isLogisticsResponsible();

    // PRIORITÉ 1 : l'utilisateur est concerné par la ligne (détenteur)
    // → toujours autorisé à cocher, quel que soit son rôle par ailleurs
    if (isConcerned) {
      return true;
    }

    // PRIORITÉ 2 : responsable logistique (non concerné par la ligne)
    // → doit attendre que les deux aient confirmé
    if (isLogisticsUser) {
      return bothConfirmed;
    }

    // PRIORITÉ 3 : autre utilisateur → interdit si en attente
    return !hasPendingStatus;
  };

  function initalizeStorage(name) {
    if (localStorage.getItem(name)) {
      localStorage.setItem(name, localStorage.getItem(name));
    } else {
      localStorage.setItem(name, "");
    }
  }

  function loadTable(name_materiel, code_immo, state, logistics_manager, status1, status2) {
    setOpenLoadingSimpleBackdrop(true);
    InventoryService.getMinePendingImmoHistory(name_materiel, code_immo, state, logistics_manager, status1, status2).then((result) => {
      if (result && result.status) {
        setRows(
          result.data.map((row) => ({
            ...row,
            id: row.history_id,
            id2: row.code_immo_id,
            code: row.code_immo,
          }))
        );
        setOpenLoadingSimpleBackdrop(false);
      } else {
        setOpenLoadingSimpleBackdrop(false);
      }
    });
  }

  useEffect(() => {
    initalizeStorage('name_materiel');
    initalizeStorage('code_immo');
    initalizeStorage('state');
    initalizeStorage('logistics_manager');
    initalizeStorage('status1');
    initalizeStorage('status2');

    localStorage.removeItem('validationAffectation');
    localStorage.removeItem('validationByRespLogisticStorage');
    localStorage.removeItem('confirmationByOldHolderStorage');
    localStorage.removeItem('validationByHolderStorage');
    localStorage.removeItem('declinedByHolderStorage');
    localStorage.removeItem('immoImmoHistoryIdStorage');
    localStorage.removeItem('immoArrayStorage');

    const name_materiel = localStorage.getItem('name_materiel');
    const code_immo = localStorage.getItem('code_immo');
    const state = localStorage.getItem('state');
    const logistics_manager = localStorage.getItem('logistics_manager');
    const status1 = localStorage.getItem('status1');
    const status2 = localStorage.getItem('status2');

    loadTable(name_materiel, code_immo, state, logistics_manager, status1, status2);
  }, []);

  const handleValidated = (id) => (ev) => {
    ev.stopPropagation();
    immoHistoryId.push(id);
    setImmoHistoryId(immoHistoryId => [...immoHistoryId]);
    localStorage.setItem("immoImmoHistoryIdStorage", immoHistoryId);
    localStorage.setItem("immoStatusStorage", "CONFIRMED");
    localStorage.setItem("validationByHolderStorage", true);

    setOpenValidateRequest(true);
  };

  const handleConfirmed = (id) => (ev) => {
    ev.stopPropagation();
    immoHistoryId.push(id);
    setImmoHistoryId(immoHistoryId => [...immoHistoryId]);
    localStorage.setItem("immoImmoHistoryIdStorage", immoHistoryId);
    localStorage.setItem("immoStatusStorage", "CONFIRMED");
    localStorage.setItem("confirmationByOldHolderStorage", true);

    setOpenValidateRequest(true);
  };

  const handleRefused = (id) => (ev) => {
    ev.stopPropagation();
    immoHistoryId.push(id);
    setImmoHistoryId(immoHistoryId => [...immoHistoryId]);
    localStorage.setItem("immoImmoHistoryIdStorage", immoHistoryId);
    localStorage.setItem("immoStatusStorage", "DECLINED");
    localStorage.setItem("validationByHolderStorage", true);

    setOpenValidateRequest(true);
  };

  // Gestion du clic sur le bouton "Rappel de validation"
  const handleReminderClick = (row) => (ev) => {
    ev.stopPropagation();
    setSelectedReminderItem(row);
    setOpenReminderDialog(true);
  };

  // Fermeture du dialogue de rappel
  const handleCloseReminderDialog = () => {
    if (sendingReminder) return;
    setOpenReminderDialog(false);
    setSelectedReminderItem(null);
  };

  // Envoi du mail de rappel via l'API
  const handleSendReminder = async () => {
    if (!selectedReminderItem) return;

    try {
      setSendingReminder(true);
      setOpenLoadingSimpleBackdrop(true);

      // Appel de l'API de rappel avec le code_immo_id
      const result = await ImmobilisationService.rappelvalidate(selectedReminderItem.code_immo_id);

      if (result && (result.status === true || result.status === "success" || result.success === true)) {
        setMessage({
          open: true,
          color: 'green',
          messageInfo: `Un mail de rappel a été envoyé avec succès pour l'immobilisation ${selectedReminderItem.code_immo}`
        });
        setOpenReminderDialog(false);
        setSelectedReminderItem(null);
      } else {
        setMessage({
          open: true,
          color: 'red',
          messageInfo: result?.message || `Échec de l'envoi du mail de rappel pour l'immobilisation ${selectedReminderItem.code_immo}`
        });
      }
    } catch (error) {
      setMessage({
        open: true,
        color: 'red',
        messageInfo: error?.message || "Une erreur est survenue lors de l'envoi du mail de rappel."
      });
    } finally {
      setSendingReminder(false);
      setOpenLoadingSimpleBackdrop(false);
    }
  };

  const handleCheckboxChange = (id) => (ev) => {
    ev.stopPropagation();

    if (ev.target.checked === true) {
      immoAffectation.push(id);
    } else {
      const index = immoAffectation.indexOf(id);
      if (index > -1) {
        immoAffectation.splice(index, 1);
      }
    }

    setImmoAffectation(immoAffectation => [...immoAffectation]);
    localStorage.setItem("immoArrayStorage", immoAffectation);
  };

  function handleCloseMessage() {
    setMessage({ ...message, open: false });
  }

  const handleCloseValidateRequest = (event) => {
    setOpenValidateRequest(false);
  }

  const columns = [
    {
      field: 'checkbox',
      width: 120,
      renderCell: (params) => {
        const selectable = canBeSelected(params.row);
        const isChecked = immoAffectation.includes(params.row.history_id);
        // On peut décocher même si la ligne est en attente,
        // mais on ne peut cocher que si autorisé (canBeSelected).
        const isDisabled = !selectable && !isChecked;

        // Message d'aide contextuel
        let tooltipMessage = "";
        if (isDisabled) {
          const isConcerned = isUserConcernedByRow(params.row);
          if (isConcerned) {
            tooltipMessage = "Vous êtes concerné par cette ligne";
          } else if (isLogisticsResponsible()) {
            tooltipMessage = "En attente de la confirmation des deux détenteurs (ancien et nouveau) avant validation";
          } else {
            tooltipMessage = "Impossible de sélectionner un élément en attente de validation";
          }
        }

        return (
          <Button disabled={isDisabled}>
            <input
              type="checkbox"
              onChange={handleCheckboxChange(params.row.history_id)}
              checked={isChecked}
              disabled={isDisabled}
              title={tooltipMessage}
            />
          </Button>
        );
      },
    },
    {
      field: "code_immo",
      headerName: "Code Immo",
      width: 170,
    },
    {
      field: "name",
      headerName: "Matériel",
      width: 250,
    },
    {
      field: "state",
      headerName: "Etat matériel",
      width: 170,
      renderCell: (params) => {
        if (params.row.state == "BON ETAT") {
          return (
            <div
              style={{
                backgroundColor: "rgb(58, 139, 58)",
                width: 250,
                textAlign: "center",
                color: "rgb(248, 248, 248)",
                fontWeight: "bold",
                fontFamily: "Arial, Helvetica, sans-serif",
              }}
            >
              {params.row.state}
            </div>
          );
        } else if (params.row.state == "MOYEN ETAT") {
          return (
            <div
              style={{
                background: "rgb(167, 167, 55)",
                width: 250,
                textAlign: "center",
                color: "rgb(248, 248, 248)",
                fontWeight: "bold",
                fontFamily: "Arial, Helvetica, sans-serif",
              }}
            >
              {params.row.state}
            </div>
          );
        } else if (params.row.state == "MAUVAIS ETAT") {
          return (
            <div
              style={{
                background: "rgb(167, 54, 54)",
                width: 250,
                textAlign: "center",
                color: "rgb(248, 248, 248)",
                fontWeight: "bold",
                fontFamily: "Arial, Helvetica, sans-serif",
              }}
            >
              {params.row.state}
            </div>
          );
        } else {
          return (
            <div
              style={{
                background: "rgb(167, 167, 55)",
                width: 250,
                textAlign: "center",
                color: "rgb(248, 248, 248)",
                fontWeight: "bold",
                fontFamily: "Arial, Helvetica, sans-serif",
              }}
            >
              MOYEN ETAT
            </div>
          );
        }
      },
    },
    {
      field: "date_inventaire",
      headerName: "Date inventaire",
      width: 170,
    },
    {
      field: "observation",
      headerName: "Observation",
      width: 250,
    },
    {
      field: "logistics_manager",
      headerName: "Resp affectation",
      width: 250,
    },
    {
      field: "new_affectation",
      headerName: "Nouveau détenteur",
      width: 250,
    },
    {
      field: "oldest_affectation",
      headerName: "Ancien détenteur",
      width: 250,
    },
    {
      field: "status_by_the_logistics_manager",
      headerName: "Validation Resp Logistique",
      width: 250,
      renderCell: (params) => {
        if (params.row.status_by_the_logistics_manager == "CONFIRMED") {
          return (
            <div
              style={{
                backgroundColor: "rgb(58, 139, 58)",
                width: 250,
                textAlign: "center",
                color: "rgb(248, 248, 248)",
                fontWeight: "bold",
                fontFamily: "Arial, Helvetica, sans-serif",
              }}
            >
              Validé
            </div>
          );
        }
        if (params.row.status_by_the_logistics_manager == "DECLINED") {
          return (
            <div
              style={{
                backgroundColor: "rgb(167, 54, 54)",
                width: 250,
                textAlign: "center",
                color: "rgb(248, 248, 248)",
                fontWeight: "bold",
                fontFamily: "Arial, Helvetica, sans-serif",
              }}
            >
              Non Validé
            </div>
          );
        }
        if (params.row.status_by_the_logistics_manager == "PENDING") {
          return (
            <div
              style={{
                background: "rgb(167, 167, 55)",
                width: 250,
                textAlign: "center",
                color: "rgb(248, 248, 248)",
                fontWeight: "bold",
                fontFamily: "Arial, Helvetica, sans-serif",
              }}
            >
              En attente de validation
            </div>
          );
        }
      },
    },
    {
      field: "status_by_the_holder",
      headerName: "Statut détenteur",
      width: 170,
      renderCell: (params) => {
        if (params.row.status_by_the_holder == "CONFIRMED") {
          return (
            <div
              style={{
                backgroundColor: "rgb(58, 139, 58)",
                width: 250,
                textAlign: "center",
                color: "rgb(248, 248, 248)",
                fontWeight: "bold",
                fontFamily: "Arial, Helvetica, sans-serif",
              }}
            >
              Validé
            </div>
          );
        }
        if (params.row.status_by_the_holder == "PENDING") {
          return (
            <div
              style={{
                background: "rgb(167, 167, 55)",
                width: 250,
                textAlign: "center",
                color: "rgb(248, 248, 248)",
                fontWeight: "bold",
                fontFamily: "Arial, Helvetica, sans-serif",
              }}
            >
              En attente de validation
            </div>
          );
        }
        if (params.row.status_by_the_holder == "DECLINED") {
          return (
            <div
              style={{
                background: "rgb(167, 54, 54)",
                width: 250,
                textAlign: "center",
                color: "rgb(248, 248, 248)",
                fontWeight: "bold",
                fontFamily: "Arial, Helvetica, sans-serif",
              }}
            >
              Non validé
            </div>
          );
        }
      },
    },
    {
      field: "status_by_the_old_holder",
      headerName: "Statut ancien detenteur",
      width: 170,
      renderCell: (params) => {
        if (params.row.status_by_the_old_holder == "CONFIRMED") {
          return (
            <div
              style={{
                backgroundColor: "rgb(58, 139, 58)",
                width: 250,
                textAlign: "center",
                color: "rgb(248, 248, 248)",
                fontWeight: "bold",
                fontFamily: "Arial, Helvetica, sans-serif",
              }}
            >
              Validé
            </div>
          );
        }
        if (params.row.status_by_the_old_holder == "PENDING") {
          return (
            <div
              style={{
                background: "rgb(167, 167, 55)",
                width: 250,
                textAlign: "center",
                color: "rgb(248, 248, 248)",
                fontWeight: "bold",
                fontFamily: "Arial, Helvetica, sans-serif",
              }}
            >
              En attente de validation
            </div>
          );
        }
        if (params.row.status_by_the_old_holder == "DECLINED") {
          return (
            <div
              style={{
                background: "rgb(167, 54, 54)",
                width: 250,
                textAlign: "center",
                color: "rgb(248, 248, 248)",
                fontWeight: "bold",
                fontFamily: "Arial, Helvetica, sans-serif",
              }}
            >
              Non validé
            </div>
          );
        }
      },
    },
    {
      field: "action",
      headerName: "Action",
      disableClickEventBulbing: true,
      width: 550,
      renderCell: (params) => {
        const isOldHolderPending = params.row.status_by_the_old_holder === "PENDING";
        const isHolderPending = params.row.status_by_the_holder === "PENDING";
        const hasPendingStatus = isOldHolderPending || isHolderPending;

        const bothConfirmed =
          params.row.status_by_the_old_holder === "CONFIRMED" &&
          params.row.status_by_the_holder === "CONFIRMED";

        const bothDeclined =
          params.row.status_by_the_old_holder === "DECLINED" &&
          params.row.status_by_the_holder === "DECLINED";

        // Identifiants utilisateur
        const currentUserId = Number(userConnectedId);
        const isOldHolder = Number(params.row.older_id) === currentUserId;
        const isNewHolder = Number(params.row.new_affectation_user_id) === currentUserId;
        const isAllowedReminderUser = ALLOWED_REMINDER_USER_IDS.includes(currentUserId);
        const isConcernedUser = isOldHolder || isNewHolder;


        const showReminderButton = hasPendingStatus && isAllowedReminderUser;

  
        let showAcceptButton = false;

        if (!bothConfirmed && !bothDeclined) {
          showAcceptButton = true;
        } else if (isAllowedReminderUser && bothConfirmed) {

          showAcceptButton = true;
        } else if (bothConfirmed) {
          showAcceptButton = true;
        }


        const showRefuseButton = hasPendingStatus && (isAllowedReminderUser);

        return (
          <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
            {/* Bouton Rappel de validation */}
            {showReminderButton && (
              <Button
                variant="contained"
                onClick={handleReminderClick(params.row)}
                title="Envoyer un mail de rappel pour la validation"
                style={{
                  fontWeight: 600,
                  backgroundColor: "rgb(25, 118, 210)",
                  color: "#FFFFFF",
                  fontSize: '12px'
                }}
              >
                Rappel de validation
              </Button>
            )}

            {/* Bouton Accepter */}
            {showAcceptButton && (
              <Button
                variant="contained"
                onClick={handleValidated(params.row.history_id)}
                title={
                  isAllowedReminderUser && bothConfirmed && !isConcernedUser
                    ? "Valider définitivement l'affectation (les deux détenteurs ont confirmé)"
                    : "Accepter l'acquisition de cet article"
                }
                style={{
                  fontWeight: 600,
                  backgroundColor: "green",
                  color: "#FFFFFF",
                  fontSize: '12px'
                }}
              >
                Accepter
              </Button>
            )}

            {/* Bouton Refuser */}
            {showRefuseButton && (
              <Button
                variant="contained"
                color="secondary"
                onClick={handleRefused(params.row.history_id)}
                title="Refuser l'acquisition de cet article"
                style={{
                  fontWeight: 600,
                  fontSize: '12px'
                }}
              >
                Refuser
              </Button>
            )}
          </div>
        );
      },
    },
  ];

  return (
    <>
      <LoadingSimpleBackdrop
        openLoadingSimpleBackdrop={openLoadingSimpleBackdrop}
      />

      <Title>Liste de(s) matériel(s) à valider ou à confirmer</Title>
      <div style={{ height: "70vh", width: "100%" }}>
        <DataGrid
          rows={rows}
          columns={columns}
          pageSize={pageSize}
          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          rowsPerPageOptions={[10, 20, 50, 100]}
          pagination
        />
      </div>

      <Message open={open} color={color} messageInfo={messageInfo} handleClose={handleCloseMessage} />

      <ValidateRequest
        openValidateRequest={openValidateRequest}
        handleCloseValidateRequest={handleCloseValidateRequest}
      />

      {/* Dialogue pour le rappel de validation */}
      <Dialog
        open={openReminderDialog}
        onClose={handleCloseReminderDialog}
        aria-labelledby="reminder-dialog-title"
        aria-describedby="reminder-dialog-description"
        maxWidth="sm"
        fullWidth
        PaperProps={{
          style: {
            borderRadius: 12,
            overflow: 'hidden',
          }
        }}
      >
        {/* En-tête avec icône et dégradé */}
        <div
          style={{
            background: 'linear-gradient(135deg, #1976d2 0%, #42a5f5 100%)',
            padding: '20px 24px',
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            color: '#fff',
          }}
        >
          <div
            style={{
              backgroundColor: 'rgba(255, 255, 255, 0.2)',
              borderRadius: '50%',
              width: 44,
              height: 44,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: 22,
            }}
          >
            ✉️
          </div>
          <div style={{ flex: 1 }}>
            <DialogTitle
              id="reminder-dialog-title"
              style={{ padding: 0, color: '#fff', fontSize: 18, fontWeight: 600 }}
            >
              Envoyer un rappel de validation
            </DialogTitle>
            <div style={{ fontSize: 13, opacity: 0.9, marginTop: 2 }}>
              Une notification sera envoyée aux détenteurs concernés
            </div>
          </div>
        </div>

        <DialogContent style={{ padding: '24px', backgroundColor: '#fafafa' }}>
          {/* Carte d'information de l'immobilisation */}
          <div
            style={{
              backgroundColor: '#fff',
              borderRadius: 8,
              padding: 16,
              border: '1px solid #e0e0e0',
              boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
              marginBottom: 20,
            }}
          >
            <div
              style={{
                fontSize: 12,
                fontWeight: 700,
                color: '#1976d2',
                textTransform: 'uppercase',
                letterSpacing: 0.5,
                marginBottom: 12,
                display: 'flex',
                alignItems: 'center',
                gap: 6,
              }}
            >
              <span>📦</span> Informations de l'immobilisation
            </div>

            {/* Code Immo */}
            <div style={{ display: 'flex', marginBottom: 10 }}>
              <div style={{ width: 130, color: '#666', fontSize: 13 }}>Code Immo</div>
              <div style={{ flex: 1, fontWeight: 600, fontSize: 13, color: '#333' }}>
                {selectedReminderItem?.code_immo || '—'}
              </div>
            </div>

            {/* Matériel */}
            <div style={{ display: 'flex', marginBottom: 10 }}>
              <div style={{ width: 130, color: '#666', fontSize: 13 }}>Matériel</div>
              <div style={{ flex: 1, fontWeight: 600, fontSize: 13, color: '#333' }}>
                {selectedReminderItem?.name || '—'}
              </div>
            </div>

            {/* Nouveau détenteur */}
            <div style={{ display: 'flex', marginBottom: 10 }}>
              <div style={{ width: 130, color: '#666', fontSize: 13 }}>Nouveau détenteur</div>
              <div style={{ flex: 1, fontWeight: 600, fontSize: 13, color: '#333' }}>
                {selectedReminderItem?.new_affectation || '—'}
              </div>
            </div>

            {/* Ancien détenteur */}
            <div style={{ display: 'flex' }}>
              <div style={{ width: 130, color: '#666', fontSize: 13 }}>Ancien détenteur</div>
              <div style={{ flex: 1, fontWeight: 600, fontSize: 13, color: '#333' }}>
                {selectedReminderItem?.oldest_affectation || '—'}
              </div>
            </div>
          </div>

          {/* Alertes de statut en attente */}
          <div
            style={{
              backgroundColor: '#fff8e1',
              borderLeft: '4px solid #ffa000',
              borderRadius: 6,
              padding: '12px 16px',
            }}
          >
            <div
              style={{
                fontSize: 13,
                fontWeight: 600,
                color: '#e65100',
                marginBottom: 8,
                display: 'flex',
                alignItems: 'center',
                gap: 6,
              }}
            >
              <span>⚠️</span> Validation(s) en attente
            </div>

            <ul style={{ margin: 0, paddingLeft: 20, fontSize: 13, color: '#5d4037' }}>
              {selectedReminderItem?.status_by_the_old_holder === 'PENDING' && (
                <li style={{ marginBottom: 4 }}>
                  En attente de validation de <strong>l'ancien détenteur</strong>
                </li>
              )}
              {selectedReminderItem?.status_by_the_holder === 'PENDING' && (
                <li>
                  En attente de validation du <strong>nouveau détenteur</strong>
                </li>
              )}
            </ul>
          </div>
        </DialogContent>

        <DialogActions
          style={{
            padding: '16px 24px',
            backgroundColor: '#fff',
            borderTop: '1px solid #e0e0e0',
          }}
        >
          <Button
            onClick={handleCloseReminderDialog}
            variant="outlined"
            disabled={sendingReminder}
            style={{
              textTransform: 'none',
              fontWeight: 600,
              borderRadius: 8,
              padding: '8px 20px',
            }}
          >
            Annuler
          </Button>
          <Button
            onClick={handleSendReminder}
            variant="contained"
            disabled={sendingReminder}
            style={{
              textTransform: 'none',
              fontWeight: 600,
              borderRadius: 8,
              padding: '8px 20px',
              background: sendingReminder
                ? '#b0bec5'
                : 'linear-gradient(135deg, #1976d2 0%, #42a5f5 100%)',
              boxShadow: '0 2px 6px rgba(25, 118, 210, 0.3)',
            }}
            startIcon={<span>📧</span>}
          >
            {sendingReminder ? 'Envoi en cours...' : 'Envoyer le rappel'}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}